@charset "UTF-8";

/* src/app/acs-chat/components/user-picker/user-picker.scss */
.user-picker-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
}
.picker-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid #e0e0e0;
  background: #fff;
  min-height: 54px;
}
.back-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #5ba4b5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover {
  background: #4a8d9e;
}
.picker-title {
  font-weight: 700;
  font-size: 18px;
  color: #333;
  flex: 1;
}
.confirm-btn {
  background: #6abf69;
  color: #fff;
  border: none;
  border-radius: 16px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s;
}
.confirm-btn:hover {
  background: #5aad59;
}
.confirm-btn:disabled {
  background: #c5e1c5;
  cursor: default;
}
.selected-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 16px;
  border-bottom: 1px solid #eee;
}
.chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #e8e8ed;
  border-radius: 14px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.chip:hover {
  background: #d1d1d6;
}
.search-box {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}
.search-label {
  font-size: 12px;
  color: #888;
  font-weight: 500;
}
.search-input-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 0 10px;
  background: #fff;
}
.search-input-wrapper input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  font-family: inherit;
  background: transparent;
  padding: 8px 0;
}
.search-input-wrapper .search-icon {
  flex-shrink: 0;
}
.search-input-wrapper:focus-within {
  border-color: #5ba4b5;
}
.user-list {
  flex: 1;
  overflow-y: auto;
}
.user-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  border-bottom: 1px solid #eee;
  transition: background 0.15s;
}
.user-row:hover {
  background: #f8f8f8;
}
.user-row.selected {
  background: #f0f7ff;
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.avatar-initials {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #7b8a9e;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
}
.user-name {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.check-mark {
  opacity: 0;
  transition: opacity 0.15s;
  flex-shrink: 0;
}
.check-mark.visible {
  opacity: 1;
}
.empty-hint {
  text-align: center;
  color: #999;
  padding: 24px;
  font-size: 14px;
}
/*# sourceMappingURL=user-picker.css.map */
